<template>
  <div class="msg-board">
    <!-- <Notice /> -->
    <!-- <van-notice-bar
      class="notice-bar"
      wrapable
      color="#B78147"
      background="#F5F5F5"
    >
      该页面为玩家留言页面 ，如需联系客服请点击页面右上角客服中心入口
    </van-notice-bar> -->
    <div class="msg-content" ref="msgContent">
      <van-pull-refresh
        :pulling-text="$t('im.下拉加载历史数据')"
        :loosing-text="$t('im.释放加载历史数据')"
        class="refresh-cont"
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :error.sync="error"
          :finished="finished"
          :error-text="$t('im.请求失败')"
          @load="onLoad"
        >
          <van-cell
            class="msg-card"
            v-for="(item, index) in msgList"
            :key="index"
          >
            <div class="title">
              <span class="name">
                {{ `${item.role_name}${(item.role_id && item.role_id == defaultRoleInfo.role_id) ? $t('im.我') : ''}` }}
              </span>
              <span>
                {{ item.created_at | timeFilter }}
              </span>
            </div>
            <div class="msg-info">
              {{ item.content }}
            </div>
          </van-cell>
          <div slot="finished" @click="handleRecent">{{ $t('im.点击加载最新留言') }}</div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="bottom-line">
      <send-msg
        ref="sendmsg"
        @focus="goBottom"
        :text="$t('im.留言')"
        :placeholder="$t('im.请输入留言内容')"
        @submit="handleSend"
      ></send-msg>
    </div>
  </div>
</template>

<script>
  import { getMsgBoardList, sendBoardMsg } from '@/api/customer';
  // import { userChooseRole } from '@/api/user';
  import { Notice, ImNotice } from '@/components/Notice';
  import { goScrollView } from '@/utils/util';
  // import moment from 'moment';
  import dayjs from 'dayjs';
  import { mapState } from 'vuex';

  export default {
    name: 'ImMsgBoard',
    data () {
      return {
        refreshing: false,
        error: false,
        finished: false,
        loading: false,
        msgList: [],
        isFirstLoad: true,
        // 加载方式：0-最新，1-历史
        loadType: 0
      };
    },
    components: { Notice, ImNotice },
    computed: {
      ...mapState({
        roleList: state => state.roleList,
        defaultRoleInfo: state => state.defaultRoleInfo,
        vuexInitData: state => state.vuexInitData
      }),
      calRoleList () {
        if (this.roleList && this.roleList.length) {
          const arr = this.roleList.map(item => ({ text: `${item.role_name}(${item.server_name})`, value: item.id }));
          arr.push({ text: `+${this.$t('im.添加新角色')}`, value: 'add' });
          return arr;
        } else {
          return [{ text: `+${this.$t('im.添加新角色')}`, value: 'add' }];
        }
      }
    },
    methods: {
      onLoad () {
        this.loadType = 0;
        this.getMsgList();
      },
      getMsgList () {
        const params = {
          page_size: 10,
          type: this.isFirstLoad ? 0 : this.loadType
        };

        if (!this.isFirstLoad) {
          params.id = this.getInfoId();
        }
        this.isFirstLoad = false;
        getMsgBoardList(params).then(res => {
          if (res.code === 0) {
            this.error = false;
            if (res.data && res.data.length) {
              const arr = this.filterMsg(res.data);
              if (this.loadType === 0) {
                this.msgList = this.msgList.concat(arr);
              } else {
                this.msgList = arr.concat(this.msgList);
              }
            } else {
              this.finished = true;
            }
          } else {
            this.error = true;
          }
        }).catch(() => {
          this.error = true;
        }).finally(() => {
          this.loading = false;
          this.refreshing = false;
        });
      },
      // 过滤掉已经存在的消息
      filterMsg (data) {
        if (!data) {
          return [];
        }
        if (this.msgList.length <= 0) {
          return data;
        }

        const res = data.reduce((acc, cur) => {
          if (this.msgList.findIndex(item => item.id === cur.id) <= -1) {
            acc.push(cur);
          }
          return acc;
        }, []);
        return res;
      },
      //  获取最新或者最老的一条数据的 id
      getInfoId () {
        if (this.msgList && this.msgList.length) {
          const { msgList } = this;
          const length = msgList.length;
          let id = null;
          if (this.loadType === 0) {
            // 获取最新的一条非本地消息的 id
            for (let i = length - 1; i >= 0; i--) {
              if (msgList[i].id) {
                id = msgList[i].id;
                break;
              }
            }
          } else {
            // 获取最老的一条非本地消息的 id
            for (let i = 0; i < length; i++) {
              if (msgList[i].id) {
                id = msgList[i].id;
                break;
              }
            }
          }
          return id;
        } else {
          return null;
        }
      },
      handleSend (value) {
        if (value) {
          const params = {
            content: value,
            role_id: this.defaultRoleInfo.role_id || this.vuexInitData.sess_uuid,
            server_id: (this.defaultRoleInfo.f_id && this.defaultRoleInfo.f_id.toString()) || '0',
            role_name: this.defaultRoleInfo.role_name || `${this.$t('im.游客')}${String(this.vuexInitData.sess_uuid).substr(this.vuexInitData.sess_uuid.length - 4)}`,
            status: 1,
            isLocal: true,
            created_at: dayjs().unix()
          };
          sendBoardMsg(params).then(res => {
            if (res.code === 0) {
              params.id = res.data && res.data.id;
              this.msgList.push(params);
              this.$refs.sendmsg.clearValue();
              this.goBottom();
            }
          }).catch(() => {
            console.log('err');
          });
        }
      },
      goBottom() {
        this.$nextTick(() => {
          goScrollView(this.$refs.msgContent, 'bottom');
        });
      },
      onRefresh () {
        this.loadType = 1;
        this.getMsgList();
      },
      // 点击加载更多
      handleRecent() {
        this.finished = false;
      }
    }
  };
</script>

<style lang="less" scoped>
.msg-board {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #E9E9E9;
  .msg-nav {
    flex: 0 0 auto;
  }
  .notice-bar {
    flex: 0 0 auto;
    margin: 0;
    font-size: 12px;
    line-height: 20px;
  }
  .msg-content {
    flex: 1;
    padding: 20px 10px 0 10px;
    box-sizing: border-box;
    overflow: scroll;
    .refresh-cont {
      min-height: 100%;
      /deep/ .van-list {
        .msg-card {
          width: 100%;
          margin-bottom: 12px;
          padding: 10px;
          box-shadow: 0px 2px 6px 0px rgba(155, 155, 155, 0.5);
          border-radius: 6px;
          font-size: 12px;
          background-color: #FFFFFF;
          box-sizing: border-box;
          .title {
            display: flex;
            align-items: center;
            width: 100%;
            padding-bottom: 10px;
            color: #A9A9A9;
            font-size: 12px;
            line-height: 14px;
            box-sizing: border-box;
            border-bottom: 1px dashed #B3B3B3;
            .name {
              margin-right: 5px;
              font-size: 13px;
            }
          }
          .msg-info {
            width: 100%;
            padding-top: 10px;
            box-sizing: border-box;
            color: @fontColor;
          }
        }
      }
    }
  }
  .bottom-line {
    width: 100%;
    border-top: 1px solid #D8D8D8;
    background-color: #fff;
    input {
      flex: 1;
      margin-right: 10px;
      padding-left: 10px;
      font-size: 14px;
      line-height: 30px;
      border-radius: 15px;
      box-sizing: border-box;
      border: 1px solid #ebedf0;
      background-color: #F2F2F2;
    }
    button {
      flex: 0 0 auto;
      width: 50px;
    }
  }
}
.dropdown{
  /deep/ .van-dropdown-menu__bar{
    box-shadow: none;
    /deep/ .van-dropdown-menu__title{
      font-size: 14px;
    }
  }
}
</style>